(function () {
  'use strict';


  /* =========================================================
     WE BUILD WEBSITES — GLOBAL THEME JAVASCRIPT

     Individual sections now control their own interactions.

     This global file ONLY manages:

     1. Reveal animations
     2. Shopify Theme Editor reveal safety

     DO NOT add section-specific sliders, menus,
     form selection, hero movement, etc. here.
  ========================================================= */


  /* =========================================================
     SHOPIFY DESIGN MODE
  ========================================================= */

  function isDesignMode() {
    return Boolean(
      window.Shopify &&
      window.Shopify.designMode
    );
  }


  /* =========================================================
     GET REVEAL ELEMENTS

     Shopify sometimes passes the section itself as the root,
     so we check both the root and its descendants.
  ========================================================= */

  function getRevealElements(root) {

    const elements = [];


    if (!root) {
      root = document;
    }


    if (
      root.nodeType === 1 &&
      root.matches &&
      root.matches('.wbw-reveal')
    ) {

      elements.push(root);

    }


    if (root.querySelectorAll) {

      root
        .querySelectorAll('.wbw-reveal')
        .forEach(function (element) {

          elements.push(element);

        });

    }


    return elements;
  }


  /* =========================================================
     FORCE REVEALS VISIBLE

     Used inside Shopify Theme Editor.
  ========================================================= */

  function showRevealElements(root) {

    getRevealElements(root)
      .forEach(function (element) {

        element.classList.add('visible');

      });

  }


  /* =========================================================
     GLOBAL REVEAL OBSERVER
  ========================================================= */

  function getRevealObserver() {

    if (window.__wbwRevealObserver) {

      return window.__wbwRevealObserver;

    }


    if (
      !('IntersectionObserver' in window)
    ) {

      return null;

    }


    window.__wbwRevealObserver =
      new IntersectionObserver(
        function (entries) {

          entries.forEach(
            function (entry) {

              if (!entry.isIntersecting) {
                return;
              }


              entry.target
                .classList
                .add('visible');


              window
                .__wbwRevealObserver
                .unobserve(
                  entry.target
                );

            }
          );

        },
        {
          threshold: 0.12,
          rootMargin: '0px 0px -4% 0px'
        }
      );


    return window.__wbwRevealObserver;
  }


  /* =========================================================
     INITIALIZE REVEALS
  ========================================================= */

  function initReveal(root) {

    if (!root) {
      root = document;
    }


    const elements =
      getRevealElements(root);


    if (!elements.length) {
      return;
    }


    /*
      Theme Editor:
      never leave editable content invisible.
    */
    if (isDesignMode()) {

      elements.forEach(
        function (element) {

          element.classList.add('visible');

        }
      );


      return;
    }


    /*
      Browser without IntersectionObserver:
      simply show everything.
    */
    const observer =
      getRevealObserver();


    if (!observer) {

      elements.forEach(
        function (element) {

          element.classList.add('visible');

        }
      );


      return;
    }


    elements.forEach(
      function (element) {

        /*
          Already visible.
        */
        if (
          element.classList.contains(
            'visible'
          )
        ) {
          return;
        }


        /*
          Already being observed.
        */
        if (
          element.dataset.wbwObserved ===
          'true'
        ) {
          return;
        }


        element.dataset.wbwObserved =
          'true';


        observer.observe(
          element
        );

      }
    );

  }


  /* =========================================================
     SHOPIFY THEME EDITOR SAFETY

     Shopify can replace section HTML live when:
     - changing an image
     - editing text
     - changing settings
     - moving blocks
     - adding/removing blocks

     This observer makes sure newly inserted reveal
     elements never remain stuck at opacity: 0.
  ========================================================= */

  function initEditorSafety() {

    if (!isDesignMode()) {
      return;
    }


    document
      .documentElement
      .classList
      .add('wbw-design-mode');


    showRevealElements(
      document
    );


    /*
      Only create one observer.
    */
    if (
      window.__wbwEditorObserver
    ) {
      return;
    }


    if (
      !document.body ||
      !('MutationObserver' in window)
    ) {
      return;
    }


    window.__wbwEditorObserver =
      new MutationObserver(
        function (mutations) {

          mutations.forEach(
            function (mutation) {

              mutation.addedNodes
                .forEach(
                  function (node) {

                    if (
                      node.nodeType !== 1
                    ) {
                      return;
                    }


                    /*
                      Include the newly inserted node itself.
                    */
                    if (
                      node.matches &&
                      node.matches('.wbw-reveal')
                    ) {

                      node.classList.add(
                        'visible'
                      );

                    }


                    /*
                      Include reveal elements inside it.
                    */
                    showRevealElements(
                      node
                    );

                  }
                );

            }
          );

        }
      );


    window
      .__wbwEditorObserver
      .observe(
        document.body,
        {
          childList: true,
          subtree: true
        }
      );

  }


  /* =========================================================
     GLOBAL INITIALIZATION
  ========================================================= */

  function initTheme(root) {

    if (!root) {
      root = document;
    }


    initReveal(
      root
    );


    /*
      Extra editor protection.
    */
    if (isDesignMode()) {

      showRevealElements(
        root
      );

    }

  }


  /* =========================================================
     INITIAL PAGE LOAD
  ========================================================= */

  function initialLoad() {

    initEditorSafety();


    initTheme(
      document
    );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialLoad,
      {
        once: true
      }
    );

  } else {

    initialLoad();

  }


  /* =========================================================
     SHOPIFY SECTION LOAD

     Runs whenever Shopify dynamically reloads a section.
  ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initTheme(
        event.target ||
        document
      );

    }
  );


  /* =========================================================
     SHOPIFY SECTION SELECT
  ========================================================= */

  document.addEventListener(
    'shopify:section:select',
    function (event) {

      initTheme(
        event.target ||
        document
      );

    }
  );


  /* =========================================================
     SHOPIFY BLOCK SELECT
  ========================================================= */

  document.addEventListener(
    'shopify:block:select',
    function (event) {

      let root =
        event.target ||
        document;


      if (
        event.target &&
        event.target.closest
      ) {

        const section =
          event.target.closest(
            '.shopify-section'
          );


        if (section) {

          root =
            section;

        }

      }


      initTheme(
        root
      );

    }
  );


  /* =========================================================
     BROWSER BACK / FORWARD CACHE

     Some browsers restore a page without a full reload.
  ========================================================= */

  window.addEventListener(
    'pageshow',
    function () {

      initTheme(
        document
      );

    }
  );

})();